$(document).on('change', 'select[data-switch]', function () {
    let currentTab = this.closest('.panel');
    let material = $(currentTab).find('[data-switch="material"]').find(':selected').attr('data-material');
    let placement = $(currentTab).find('[data-switch="placement"]').find(':selected').attr('data-placement');

    let extraDimensionsDiv = $(currentTab).find('.extra-dimensions');

    switch(placement) {
        case 'below':
            extraDimensionsDiv.addClass('d-none');
            extraDimensionsDiv.find('.form-control').attr('disabled', true);
            break;
        case 'above':
            extraDimensionsDiv.removeClass('d-none');
            extraDimensionsDiv.find('.form-control').attr('disabled', false);
            let dimensionH = extraDimensionsDiv.find('.dimension-h');
            if (material === 'metal') {
                dimensionH.removeClass('d-none');
                dimensionH.find('.form-control').attr('disabled', false);
            } else {
                dimensionH.addClass('d-none');
                dimensionH.find('.form-control').attr('disabled', true);
            }
            break;
    }

    let allImages = $(currentTab).find('img[data-window-placement]');
    let targetImage = $(currentTab).find('[data-well-material="' + material + '"][data-window-placement="' + placement + '"]');

    [...allImages].forEach(el => {
        el.classList.add('d-none');
    });
    $(targetImage).removeClass('d-none');
});

$(document).on('change', '[data-toggle-hidden]', function () {
    let showElement, hideElements;

    if (this.tagName === 'SELECT') {
        let targetLabel = $(this).find(':selected').attr('data-show');
        let targetClass = $(this).find(':selected').attr('data-hide-collection');
        showElement = $(`[data-hidden-element='${targetLabel}']`);
        hideElements = $(`[data-collection='${targetClass}']`);
    } else {
        showElement = $(`[data-hidden-element='${this.dataset.show}']`);
        hideElements = $(`[data-collection='${this.dataset.hideCollection}']`);
    }

    hideElements.find('.form-control, .custom-control-input').attr('disabled', true);
    hideElements.addClass('d-none');

    if (showElement.length) {
        showElement.find('.form-control, .custom-control-input').attr('disabled', false);
        showElement.removeClass('d-none');
    }
});
